import { render, staticRenderFns } from "./ModalPaymentFailedHistory.vue?vue&type=template&id=2c8a9b5c&scoped=true&"
import script from "./ModalPaymentFailedHistory.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentFailedHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentFailedHistory.vue?vue&type=style&index=0&id=2c8a9b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a9b5c",
  null
  
)

export default component.exports